import { filterNullable } from "@-/com.npmjs.array-utils-ts";
import type { ReferenceWordMorphemeSlice } from "@-/dev.improve.haniverse.lib.morpheme.entities";
import type { MorphemeInfoPanelAccordionSectionDescriptor } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content._components.morpheme-info-panel-accordion";
import { useMorphemeInfoPanelSentencesExamplesSection } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content.views.sentences.__sections.examples";

/** A word's usage sections as descriptors, for the Dictionary tab to render below its own. */
export function useMorphemeInfoPanelSentencesWordSections({
  wordCard,
}: {
  wordCard: ReferenceWordMorphemeSlice;
}): MorphemeInfoPanelAccordionSectionDescriptor[] {
  const examples = useMorphemeInfoPanelSentencesExamplesSection({ infoBackCardSlice: wordCard });
  return filterNullable([examples]);
}
